import { saveConsentValue } from './consentUtils';
import { COMSCORE_CMP } from './ids';
import { cmpLog, LOG_TYPE_INFO, logResults, LOG_TYPE_ERROR, LOAD_CONSENT, LOAD_CONSENT_FAILED, SUCCESS, FAILED } from './logger';
var PARTNER = 'COMSCORE';
var comscoreConsent;
export default (function (_, success) {
  cmpLog(LOG_TYPE_INFO, "".concat(LOAD_CONSENT, " [").concat(PARTNER, "]"), success ? SUCCESS : FAILED);

  if (success) {
    comscoreConsent = window.consents.getConsent(COMSCORE_CMP);
    window.consents.comscore = comscoreConsent.vendor ? comscoreConsent.consent : comscoreConsent;
    var ucfr = Number(Boolean(window.consents.comscore)).toString();
    global.cmpComscoreUcfr = ucfr;
    saveConsentValue('cmpComscoreUcfr', ucfr);
    logResults('comscore', comscoreConsent);
  } else {
    cmpLog(LOG_TYPE_ERROR, "".concat(LOAD_CONSENT_FAILED, " ").concat(PARTNER));
  }
});